import React from "react";
import CardEmpty from "Utils/Cards/CardEmpty";
import LoadMask from "Utils/LoadMask/LoadMask";
import { DatosTurnoDetalle } from "../../../DetalleTurnoFinalizado/components/DatosTurnoDetalle";
import { useTancadasTurno } from "../hooks/useTancadasTurno";
import { ComparativoProduccion } from "./ComparativoProduccion";
import { ResumenTancadasTurno } from "./ResumenTancadasTurno";
import { TancadasTurnoTable } from "./TancadasTurnoTable";

export const TancadasTurnoContent = ({ turnoId, regresar }) => {
    const {
        turno,
        drcPadresPT,
        resumen,
        comparativo,
        tancadas,
        mensajeError,
        cargando,
        DescargarExcel,
    } = useTancadasTurno(turnoId);

    return (
        <div className="view__tab-wrapper">
            <LoadMask loading={cargando} blur>
                <CardEmpty noShadow>
                    {mensajeError && (
                        <div className="text-center py-5">
                            <h3>{mensajeError}</h3>
                        </div>
                    )}

                    {turno && (
                        <React.Fragment>
                            <DatosTurnoDetalle
                                turno={turno}
                                drcPadresPT={drcPadresPT}
                                titulo={
                                    turno.en_curso
                                        ? "Turno en curso"
                                        : "Turno finalizado"
                                }
                            />

                            <h4 className="mt-4 mb-3">Resumen de tancadas</h4>

                            {resumen && (
                                <ResumenTancadasTurno resumen={resumen} />
                            )}

                            {comparativo && (
                                <ComparativoProduccion
                                    comparativo={comparativo}
                                />
                            )}

                            <h4 className="mt-4 mb-3">Tancadas del turno</h4>

                            <TancadasTurnoTable tancadas={tancadas} />
                        </React.Fragment>
                    )}

                    <div className="d-flex flex-wrap justify-content-center my-4 gap-2rem">
                        <button
                            className="btn btn-outline-dark"
                            onClick={regresar}
                        >
                            Regresar
                        </button>

                        {turno && (
                            <button
                                className="btn btn-secondary"
                                onClick={DescargarExcel}
                                disabled={cargando}
                            >
                                Exportar a Excel
                            </button>
                        )}
                    </div>
                </CardEmpty>
            </LoadMask>
        </div>
    );
};
